// styles for push-example when resizing window
(function() {
  const pushExampleArr = document.querySelectorAll('.js-push-example');
  pushExampleArr.forEach((pushExample) => {
    const iconBox = pushExample.querySelector('.js-push-example-icon');
    const contentBox = pushExample.querySelector('.js-push-example-body');
    let boxWidth = pushExample.offsetWidth;

    function setHeight(box) {
      const h = box.offsetWidth;
      box.style.height = `${ h }px`;
    }

    function setFontSize(box, callback) {
      const size = 0.05 * box.offsetWidth;
      box.style.fontSize = `${ size }px`;

      if (callback) {
        callback();
      }
    }

    setFontSize(contentBox, () => setHeight(iconBox));

    window.addEventListener('resize', () => {
      if (boxWidth !== pushExample.offsetWidth) {
        boxWidth = pushExample.offsetWidth;
        setFontSize(contentBox, () => setHeight(iconBox));
      }
    })
  })
})();